export function getEnvironment(
	nodeEnvironment: "production" | "development" | "test",
	isStaging?: "true" | "false",
): "production" | "development" | "staging" {
	if (isStaging === "true" && nodeEnvironment === "production") {
		return "staging";
	}

	if (nodeEnvironment === "test") {
		return "development";
	}

	return nodeEnvironment;
}
